import { RouteObject } from 'react-router';
import Home from '../page/home';
// import EX000002 from '../page/ex000002';
// import EX000001 from '../page/ex000001';
import ApiPermission from '../page/api-permission';
import TokenInfo from '../page/token-info';
import ApiRecord from '../page/api-record';

export type MenuRouteObject = RouteObject & {
	name?: string;
	childMenu?: MenuRouteObject[];
};

const menus: MenuRouteObject[] = [
	{
		path: '',
		element: <Home />,
		name: 'api查詢',
	},
	{
		name: 'api連接帳號及權限',
		path: '/api-permission',
		element: <ApiPermission />,
	},
	{
		name: 'token維護',
		path: '/token-info',
		element: <TokenInfo />,
	},
	{
		name: 'api使用紀錄',
		path: '/api-record',
		element: <ApiRecord />,
	},
	// {
	// 	name: '其他',
	// 	childMenu: [
	// 		{
	// 			name: '範例1',
	// 			path: '/example1',
	// 			element: <EX000001 />,
	// 		},
	// 		{
	// 			name: '範例2',
	// 			path: '/example2',
	// 			element: <EX000002 />,
	// 		},
	// 	],
	// },
];

let menuRoutes: RouteObject[] = [];
function generateRoutes(menus: MenuRouteObject[]) {
	menus.forEach((item) => {
		if (item.childMenu) {
			generateRoutes(item.childMenu);
		} else {
			menuRoutes.push(item);
		}
	});
}
generateRoutes(menus);

export { menus, menuRoutes };
